
export const STATE_DRAFT = 1;
export const STATE_APPROVED = 2;
export const STATE_SCHEDULED = 3;
export const STATE_CANCELLED = 4;
export const STATE_COMPLETED = 5;

export const states = [
    {
        id: STATE_DRAFT,
        color: 'grey'
    },
    {
        id: STATE_APPROVED,
        color: 'orange'
    },
    {
        id: STATE_SCHEDULED,
        color: 'blue'
    },
    {
        id: STATE_CANCELLED,
        color: 'red'
    },
    {
        id: STATE_COMPLETED,
        color: 'green'
    },

];
